/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/show-more/index.js}] */
"use strict";
(() => {
  // _js/standalone/show-more/index.js
  var ShowMoreButton = class extends HTMLElement {
    constructor() {
      super(), this.querySelector("button").addEventListener("click", (event) => {
        this.expandShowMore(event);
        let nextElementToFocus = event.target.closest(".parent-display").querySelector(".show-more-i\
tem");
        nextElementToFocus && !nextElementToFocus.classList.contains("hidden") && nextElementToFocus.
        querySelector("input").focus();
      });
    }
    expandShowMore(event) {
      let parentDisplay = event.target.closest('[id^="Show-More-"]').closest(".parent-display");
      this.querySelectorAll(".label-text").forEach(
        (element) => element.classList.toggle("hidden")
      ), parentDisplay.querySelectorAll(".show-more-item").forEach((item) => item.classList.toggle("\
hidden"));
    }
  };
  customElements.define("show-more-button", ShowMoreButton);
})();
